export default __webpack_public_path__ + "static/media/zennoodle.2fe843cb.jpeg";